import { useDispatch, useSelector } from '../../../../store/store';
import { validateGPA } from '../../../../utils/generalHelpers';
import MotionWrapper from '../../../../containers/MotionWrapper';
import RadioButton from '../../../../components/RadioButton';
import EducationForm from '../../components/EducationForm';
import Button from '../../../../components/Button';
import styles from './style.module.scss';
import { useState } from 'react';
import {
    selectEditMode,
    selectEducationInfo,
} from '../../../../store/signUp/selectors';
import {
    setSignUpStep,
    setEducationInfo,
    resetEducationInfo,
} from '../../../../store/signUp/slice';

function Education() {
    const dispatch = useDispatch();
    const editMode = useSelector(selectEditMode);
    const educations = useSelector(selectEducationInfo);
    const [noEducation, setNoEducation] = useState(false);

    const next = () => {
        dispatch(setSignUpStep(editMode ? 'reviewInfo' : 'expertise'));
    }

    const disableNextStep = educations.some(({
        GPA,
        from,
        to,
        field,
        degree,
        universityName,
        didNotFinishDegree,
    }) => {

        return !validateGPA(GPA) ||
            !from ||
            !field ||
            !degree ||
            !universityName ||
            !(didNotFinishDegree || to !== "") ||
            new Date(from) > new Date(to);
    })

    const haveNoEducation = (val: boolean) => {
        setNoEducation(val);
        dispatch(resetEducationInfo());
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <RadioButton
                text="I don't have academic education"
                checked={noEducation}
                setChecked={haveNoEducation}
            />
            {educations.map(item => <EducationForm data={item} />)}
            <Button
                text={educations.length === 0 ? '+ Add education' : '+ Add another'}
                className={styles.add}
                type='Outline-Primary'
                onClick={() => dispatch(setEducationInfo())}
                disabled={educations.length === 5}
            />
            <div className={styles.actions}>
                <Button
                    size='sm'
                    text='Back'
                    type='Outline-Dark'
                    onClick={() => dispatch(setSignUpStep('uploadPersonalID'))}
                    className={styles.actions_btn}
                />
                <Button
                    size='sm'
                    type='Primary'
                    onClick={next}
                    className={styles.actions_btn}
                    text={editMode ? 'Save' : 'Continue'}
                    disabled={(educations.length === 0 ? !noEducation : disableNextStep)}
                />
            </div>
        </MotionWrapper>
    );
};

export default Education;
